import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ArbeitspaketeListe } from '../components/ArbeitspaketeListe';
import { ProjectGanttSection } from '../components/ProjectGanttSection';
import { MilestoneSection } from '../components/MilestoneSection';

/**
 * Arbeitspakete-Tab: die AP-Liste (Tabelle/WBS/Mindmap/Abhaengigkeiten), darunter
 * der Zeitplan (Gantt der APs) und darunter die Meilensteine. Liste, Zeitplan und
 * Meilensteine sind als wiederverwendbare Komponenten ausgelagert (auch vom
 * Projektplan-Tab genutzt).
 */
export function ArbeitspaketeTab({ projectId }: { projectId: string }) {
  const { t } = useTranslation('projects');

  return (
    <Stack spacing={4}>
      <ArbeitspaketeListe projectId={projectId} />

      <Box>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {t('arbeitspakete.zeitplan', 'Zeitplan')}
        </Typography>
        <ProjectGanttSection projectId={projectId} />
      </Box>

      <MilestoneSection projectId={projectId} />
    </Stack>
  );
}
